module.exports = __webpack_public_path__ + "static/media/home-icon.48a49a39.svg";